"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Twitter24Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M24,4.36756114 C23.1169538,4.76913106 22.1679798,5.04053507 21.1719522,5.16259936 C22.1886097,4.537695 22.9692966,3.5482181 23.3369472,2.36925348 C22.385603,2.94779861 21.3318117,3.36800223 20.2102491,3.5944873 C19.3120158,2.61320203 18.0323494,2 16.6161747,2 C13.8968068,2 11.6921321,4.26061986 11.6921321,7.04892474 C11.6921321,7.44464348 11.7357621,7.83001017 11.8196862,8.19953371 C7.72742236,7.98898181 4.09928673,5.9788818 1.67075606,2.92421392 C1.24692198,3.66992231 1.00410403,4.53724491 1.00410403,5.46253905 C1.00410403,7.21419763 1.8734555,8.75962517 3.19464501,9.66502534 C2.3874465,9.63883013 1.62826731,9.41171493 0.964336662,9.03354968 C0.963985515,9.05461387 0.963985515,9.07576808 0.963985515,9.09701231 C0.963985515,11.5433391 2.66125315,13.5840452 4.91377154,14.0478175 C4.50055964,14.1632205 4.06557665,14.2248828 3.61646,14.2248828 C3.29919895,14.2248828 2.99071656,14.1932865 2.69013497,14.1343247 C3.3166685,16.1402839 5.13508175,17.6000144 7.28971799,17.6407925 C5.60456491,18.994932 3.48144409,19.8021226 1.17458576,19.8021226 C0.777175464,19.8021226 0.385207945,19.7782679 0,19.7316386 C2.17904093,21.1641837 4.76725557,22 7.54789861,22 C16.6046746,22 21.5572479,14.306439 21.5572479,7.63440125 C21.5572479,7.41547768 21.5525074,7.19772435 21.5430264,6.98123127 C22.5049929,6.2693696 23.3398442,5.38008264 24,4.36756114", id: `twitter24-${id0}` })),
        react_1.default.createElement("g", { id: "twitter-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#twitter24-${id0}` })),
            react_1.default.createElement("use", { id: "Fill-1", fill: "#000000", xlinkHref: `#twitter24-${id0}` })));
}
function Twitter24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Twitter24Svg, Object.assign({}, svgProps)));
}
exports.default = Twitter24;
//# sourceMappingURL=Twitter24.js.map